'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

exports.default = _react.PropTypes.shape({
  addLayer: _react.PropTypes.func.isRequired,
  removeLayer: _react.PropTypes.func.isRequired
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-leaflet/lib/types/layerContainer.js
 ** module id = 86
 ** module chunks = 0
 **/